export const config = {
    RECAPTCHA_CLIENT_KEY: "6LcUjHwpAAAAAP10V2svmHSFpsrJJRQTeWaNsTPw"
}